export default __webpack_public_path__ + "static/N0281-ba3ba85271f4e696dd9d2a99a85a9af4.png";